import { CommonsV1ApiBase } from './base';
import { Notification } from '../types/notifications';
import { Service } from '../../commonv3/types/service';

export const NotificationApis = {
  base() {
    return CommonsV1ApiBase.appendPath('users/current');
  },
  peekNotification(): Promise<Notification> {
    return this.base().appendPath('notifications').get({ current_service: Service.LIKES });
  },
  removeNotification(notification: Notification): Promise<void> {
    return this.base().appendPath('notifications').delete({ type: notification.type, id: notification.id });
  },
};
